import { DataGridBodyProps } from '../types'
import { DataGridRow } from '.'
import { useEffect } from 'react'

function DataGridBody<TData>(props: DataGridBodyProps) {
    const {
        defaultColDef, rowData, columnDefs, noRowNo,
        setRowData
    } = props

    useEffect( () => {
        rowData.forEach( ( row, index ) => {
            const { uuid } = row

            row.rowSeq = index + 1
            row.uuid = uuid || Math.random()
        } )
        setRowData( rowData )
    }, [ rowData ] )

    return (
        <div className="data-grid-body-container">
            {
                rowData.map( ( data, idx ) => {
                    return <DataGridRow<TData>
                        key={`${ data?.uuid }${ idx }`}
                        defaultColDef={defaultColDef}
                        columnDefs={columnDefs}
                        idx={idx}
                        data={data}
                        rowData={rowData}
                        noRowNo={noRowNo}
                        setRowData={setRowData}
                    />
                })
            }
        </div>
    )
}

export default DataGridBody